import { connect } from 'react-redux';
import { SearchView } from './SearchView';
import dropdownStateSelector from '../../../data/dropdown-state/dropdownStateSelector';
import { textBoxChange, chooseSearchItem } from '../../../data/dropdown-state/dropdownStateActions';

export function mapStateToProps(state) {
    const currentState = dropdownStateSelector(state);

    if (!currentState.searchItems) {
        return {
            isLoading: true,
        };
    }

    return {
        carriers: currentState.searchItems.carriers || [],
        plans: currentState.searchItems.plans || [],
        top: currentState.searchItems.top || [],
        typedValue: currentState.typedValue,
        carrier: currentState.carrier,
        plan: currentState.plan,
    };
}

export const mapDispatchToProps = {
    textBoxChange,
    clickHandler: chooseSearchItem,
};

export const SearchConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchView);
